export default "__VITE_ASSET__CSa$yAv$__"